<div class="col">
    <app-data-box [headerTitle]="titleTotals" [dataBoxItems]="dataItemTotal"></app-data-box>
    <app-data-box [headerTitle]="titleYear" [dataBoxItems]="dataItemYear"></app-data-box>
    <app-data-box [headerTitle]="titleMonth" [dataBoxItems]="dataItemMonth"></app-data-box>
</div>
